/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { SendErrorReportRequest } from '../models/SendErrorReportRequest';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class ErrorReportControllerv2Service {
    constructor(public readonly http: HttpClient) {}
    /**
     * @param requestBody
     * @returns binary
     * @throws ApiError
     */
    public errorReportControllerv2SendErrorReport(
        requestBody: SendErrorReportRequest,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v2/error',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
